import React from "react";

import {Header as MyHeader} from "../../../components";

import {Redirect, Route, Switch} from "react-router";

import {Container, Grid} from "semantic-ui-react";

import {Categories} from './Categories'
import {Courses} from './Courses'
import {Products} from './Products'
import {Orders} from './Orders'
import {Responsible} from "./Responsible";
import {Params} from './Params'

export const Place = () => {
    return (
        <React.Fragment>
            <MyHeader/>
            <Container>
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            <Switch>
                                <Route exact path={'/place/categories'}>
                                    <Categories/>
                                </Route>
                                <Route path={'/place/courses'} component={Courses} />
                                <Route path={'/place/products'} component={Products} />
                                <Route exact path={'/place/orders'}>
                                    <Orders/>
                                </Route>
                                <Route path={'/place/responsible'} component={Responsible} />
                                <Route path={'/place/params'} component={Params} />
                                <Redirect to={'/place/categories'} />
                            </Switch>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </React.Fragment>
    )
}

